var map = {
	"./class-operation-v2/locales/en.json": "f1ba",
	"./class-operation-v2/locales/kh.json": "f552",
	"./currency/locales/en.json": "c667",
	"./currency/locales/kh.json": "bfde",
	"./daily-closeout-report/locales/en.json": "f8d0",
	"./daily-closeout-report/locales/kh.json": "8693",
	"./exchange-rate/locales/en.json": "6a2a",
	"./invoice-ajustment/locales/en.json": "e35b",
	"./invoice-ajustment/locales/kh.json": "d2ef",
	"./monthly-semester-mapping/locales/en.json": "95eb",
	"./monthly-semester-mapping/locales/kh.json": "139f",
	"./payment-statistic/locales/en.json": "de02",
	"./payment-statistic/locales/kh.json": "27c1",
	"./score-copy/locales/en.json": "babf",
	"./score-copy/locales/kh.json": "c7ec",
	"./student-statistic/locales/en.json": "6fec",
	"./student-statistic/locales/kh.json": "3038"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "43e2";